import React from 'react';

export const JobOrderProfileV2 = () => {
  return <div>JobOrderProfileV2</div>;
};
